export enum GovernmentIdType {
  DRIVERS_LICENSE = 'Drivers License',
  INS_PERMANENT_RESIDENT_ALIEN_CARD = 'INS Permanent Resident Alien Card',
  PASSPORT = 'Passport',
  FOREIGN_NATIONAL_IDENTIFICATION_DOCUMENT = 'Foreign National Identification Document',
  // if we add back this option, we'll need to add another form field to store the "other" selection
  //OTHER = 'Other',
}
